const _UTILS = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });  
  }
};

function readMore() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductMain', () => ({
    cache: {},
    gallery: null,
    init() {
      this.InitCache();
      this.InitWatchers();
      this.InitSelf();
    },
    InitCache() {
      let am = this;
      am.cache.$gallery = am.$el.querySelector('.product_gallery');
    },
    InitSelf() {
      let am = this;
      am.MoveWishlist();
    },
    InitWatchers() {
      let am = this;
      am.cache.$gallery.addEventListener('gallery-ready', (e) => {
        // console.log(e);
        am.gallery = Flickity.data(am.cache.$gallery);
        am.gallery.on('change', am.OnGalleryChange.bind(am));
      });
    },
    OnGalleryChange(index) {
      let am = this;
      let $currentSlide = am.cache.$gallery.querySelector('.gallery-cell.is-selected');
      let variant = JSON.parse($currentSlide.dataset.variant);
      if (!variant) return;
      am.UpdateVariant(variant);
    },
    UpdateVariant(variant) {
      let am = this;
      // console.log(variant);
      variant.options.forEach((optionValue, optionIndex) => {
        let $select = am.$el.querySelector(`.single-option-selector[data-option="option${optionIndex+1}"]`);
        if ($select.value == optionValue) return;
        $select.value = optionValue;
        $select.dispatchEvent(new Event('change', {bubbles: true}));
      });
    },
    MoveWishlist() {
      let am = this;
      _UTILS.ObserveMutation('#widget-fave-html', {}, (m) => {
        if (!am.$el.querySelector('.wishlist-container #widget-fave-html')) {
          am.$el.querySelector('.wishlist-container').insertAdjacentElement('beforeend', am.$el.querySelector('#widget-fave-html'));
        }
        console.log(m);
      });
    }
  }));
});